import { useEffect, useState } from 'react';
import { GOOGLE_API_KEY, SHEETS, CALENDAR_ID } from '../config';

const cache = new Map();

/** Fetches (and remembers) the cell values of one configured sheet. */
export function fetchRows(key) {
  if (cache.has(key)) return cache.get(key);
  const sheet = SHEETS[key];
  if (!sheet) return Promise.resolve([]);
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheet.id}/values/${sheet.range}?key=${GOOGLE_API_KEY}`;
  const p = fetch(url)
    .then((res) => {
      if (!res.ok) throw new Error(`Google Sheets returned ${res.status} for "${key}"`);
      return res.json();
    })
    .then((json) => json.values || [])
    .catch((err) => { cache.delete(key); throw err; });
  cache.set(key, p);
  return p;
}

/** Upcoming events from the Google Calendar (soonest first). */
export function fetchEvents() {
  if (cache.has('calendar')) return cache.get('calendar');
  const url = 'https://www.googleapis.com/calendar/v3/calendars/' + encodeURIComponent(CALENDAR_ID) +
    '/events?orderBy=startTime&singleEvents=true&maxResults=50' +
    '&timeMin=' + encodeURIComponent(new Date().toISOString()) + '&key=' + GOOGLE_API_KEY;
  const p = fetch(url)
    .then((res) => {
      if (!res.ok) throw new Error(`Google Calendar returned ${res.status}`);
      return res.json();
    })
    .then((json) => json.items || [])
    .catch((err) => { cache.delete('calendar'); throw err; });
  cache.set('calendar', p);
  return p;
}

/** { status: 'loading' | 'ready' | 'error', data } */
function useAsync(loader) {
  const [state, setState] = useState({ status: 'loading', data: null });
  useEffect(() => {
    let live = true;
    loader()
      .then((data) => live && setState({ status: 'ready', data }))
      .catch((err) => {
        console.warn('[izetrio]', err.message);
        if (live) setState({ status: 'error', data: null });
      });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return state;
}

export const useSheet = (key) => useAsync(() => fetchRows(key));
export const useEvents = () => useAsync(fetchEvents);
